<div *transloco="let tAddView; read: 'add_view'" class="flex gap-2 flex-col">
    @for (view of views(); track view) {
        @if (view.active) {
            <div class="flex gap-2 w-full h-full text-textLight">
                <app-tb-icon class="mr-1" [icon]="view.icon"></app-tb-icon>
                <span>{{ tAddView(view.name) }}</span>
            </div>
        }
    }
</div>
